document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  function getProductDataByVariantId(variantId) {
    const script = document.querySelector(
      `[data-product-data][data-variant-id="${variantId}"]`
    );
    if (!script) {
      console.warn('No product data found for variantId', variantId);
      return null;
    }
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('Error parsing product data for variantId', variantId, e);
      return null;
    }
  }

  function pushAddToCartEvent(variantId) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const discount = Math.max(0, maxPrice - finalPrice);
    const itemId = productData.sku || variantId;
    const cartData = window.GTMData.value;
    // Recupera la quantità dall'input associato al variantId
    let quantity = 1;
    const input = document.querySelector(
      `.quantity__input[data-quantity-variant-id="${variantId}"]`
    );
    if (input && input.value) {
      quantity = parseInt(input.value, 10) || 1;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: productData.currency,
        value: cartData,
        items: [
          {
            item_name: productData.title,
            item_id: itemId,
            price: finalPrice,
            item_brand: productData.vendor,
            quantity: quantity,
            discount: discount,
          },
        ],
      },
    });
    console.log('[GA4] Evento add_to_cart inviato:', window.dataLayer);
  }

  function pushRemoveFromCartEvent(variantId, quantityOverride) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const cartData = window.GTMData.value;
    const discount = Math.max(0, maxPrice - finalPrice);
    const itemId = productData.sku || variantId;
    let quantity;
    if (typeof quantityOverride === 'number') {
      quantity = quantityOverride;
    } else {
      // Recupera la quantità dall'input associato al variantId
      quantity = 1;
      const input = document.querySelector(
        `.quantity__input[data-quantity-variant-id="${variantId}"]`
      );
      if (input && input.value) {
        quantity = parseInt(input.value, 10) || 1;
      }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: productData.currency,
        value: cartData,
        items: [
          {
            item_name: productData.title,
            item_id: itemId,
            price: finalPrice,
            item_brand: productData.vendor,
            quantity: quantity,
            discount: discount,
          },
        ],
      },
    });
    console.log('[GA4] Evento remove_from_cart inviato:', window.dataLayer);
  }

  cartDrawer.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.plusAddToCartMiniCart');
    const removeBtn = e.target.closest('.button-remove-cart');
    const minusBtn = e.target.closest('.quantity__button[name="minus"]');

    if (addBtn && addBtn.dataset.variantId) {
      pushAddToCartEvent(addBtn.dataset.variantId);
    }

    if (removeBtn && removeBtn.dataset.variantId) {
      // Quando clicchi sul cestino, passa la quantità attuale dell'input
      const input = removeBtn
        .closest('.cart-item, tr.cart-item')
        ?.querySelector('.quantity__input');
      let quantity = 1;
      if (input && input.value) {
        quantity = parseInt(input.value, 10) || 1;
      }
      pushRemoveFromCartEvent(removeBtn.dataset.variantId, quantity);
    }

    if (minusBtn) {
      const input = minusBtn
        .closest('.quantity-container')
        ?.querySelector('.quantity__input');
      if (!input) return;

      const currentQty = parseInt(input.value, 10);
      const variantId = input.dataset.quantityVariantId;

      if (variantId && currentQty > 0) {
        pushRemoveFromCartEvent(variantId, 1);
      }
    }
  });
});
